import React, { useState, useEffect } from "react";
import {
  AppBar,
  RadioGroup,
  Tabs,
  Tab,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  ListItemButton,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  Container,
  Link,
  Button,
  CircularProgress,
  Divider,
  Chip,
  IconButton,
} from "@mui/material";
import {
  CloudUpload,
  GetApp,
  Delete,
  InsertDriveFile,
  Description,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { TabPanel, a11yProps } from "./TabPanel"; // You need to define TabPanel and a11yProps
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import EditOffIcon from "@mui/icons-material/EditOff";
import AdminRegistrationForm from "./AdminRegistrationForm";
import AdminList from "./AdminList";
import CottonAdminPage from "./CottonAdminPage";
import CornAdminPage from "./CornAdminPage";
import { jwtDecode } from "jwt-decode";
import { saveAs } from "file-saver";
import ContractPrices from "./ContractPrices"; // Import the ContractPrices component
import CornContractPrices from "./CornContractPrices"; // Import the Corn ContractPrices component

function FilterAdminPage() {
  const [adminCrops, setAdminCrops] = useState([]);
  const [value, setValue] = useState(0);
  const [value1, setValue1] = useState(0);
  const [cornUsers, setCornUsers] = useState([]);
  const [cottonUsers, setCottonUsers] = useState([]); // Change to cottonUsers
  const [selectedUser, setSelectedUser] = useState(null);
  const [submittedHybridForms, setSubmittedHybridForms] = useState([]);
  const [submittedCottonHybridForms, setSubmittedCottonHybridForms] = useState(
    [],
  );
  const [seedingsubmittedForms, setseedingSubmittedForms] = useState([]);
  const [seedingcottonsubmittedForms, setseedingcottonSubmittedForms] =
    useState([]);
  const [NitrogentableData, setNitrogenTableData] = useState([]);
  const [NitrogenCottontableData, setNitrogenCottonTableData] = useState([]);
  const [Irrigationapplications, setIrrigationApplications] = useState([]);
  const [IrrigationCottonapplications, setIrrigationCottonApplications] =
    useState([]);
  const [InsuranceFormData, setInsuranceFormData] = useState([]);
  const [InsuranceCottonFormData, setInsuranceCottonFormData] = useState([]);
  const [marketingOptions, setMarketingOptions] = useState([]);
  const [marketingCottonOptions, setMarketingCottonOptions] = useState([]);
  const [growthRegulationCotton, setGrowthRegulationCotton] = useState([]);

  const [defaultfiles, setDefaultFiles] = useState([]);
  const [insurancefiles, setInsuranceFiles] = useState([]);
  const [marketingfiles, setMarketingFiles] = useState([]);
  const [cottondefaultfiles, setCottonDefaultFiles] = useState([]);
  const [cottoninsurancefiles, setCottonInsuranceFiles] = useState([]);
  const [cottonmarketingfiles, setCottonMarketingFiles] = useState([]);
  const [fileInput, setFileInput] = useState(null);
  const [showAdminPage, setShowAdminPage] = useState(false);
  // const username = localStorage.getItem("username");
  const [showFileManagement, setShowFileManagement] = useState(false);
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const [profileImageUrl1, setProfileImageUrl1] = useState(null);
  const token = localStorage.getItem("token");
  const [cottonteamMembers, setCottonTeamMembers] = useState([]);
  const [showMarketingPrices, setShowMarketingPrices] = useState(false);

  const decoded = jwtDecode(token);
  const adminId = decoded.id;

  let navigate = useNavigate();

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFilei, setSelectedFilei] = useState(null);
  const [selectedFilem, setSelectedFilem] = useState(null);
  const [selectedFiled, setSelectedFiled] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [soilMoistureSensor, setSoilMoistureSensor] = useState("");
  const [isApplicationTypeConfirmed1, setIsApplicationTypeConfirmed1] =
    useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [isApplicationTypeConfirmed, setIsApplicationTypeConfirmed] =
    useState(false);
  const [ApplicationType, setApplicationType] = useState("");
  const [isApplicationTypeConfirmedN, setIsApplicationTypeConfirmedN] =
    useState(false);
  const [
    isApplicationTypeConfirmedNCotton,
    setIsApplicationTypeConfirmedNCotton,
  ] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState({});
  const [uploadingFile, setUploadingFile] = useState(null);

  const handleCloseAdminPage = () => {
    setShowAdminPage(false);
  };

  const handleLogout = () => {
    // Clear localStorage or sessionStorage as needed
    localStorage.clear(); // or sessionStorage.clear();

    // Redirect to the login page
    window.location.href = "/login"; // Adjust the path as needed
  };

  // Handler for file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleMarketingFileChange = (event) => {
    setSelectedFilem(event.target.files[0]);
  };

  const handleInsuranceFileChange = (event) => {
    setSelectedFilei(event.target.files[0]);
  };

  const handleDefaultFileChange = (event) => {
    setSelectedFiled(event.target.files[0]);
  };

  const handleAdminRegistration = () => {
    setShowAdminPage(!showAdminPage);
  };

  const [selectedFile1, setSelectedFile1] = useState(null);

  // Handler for file selection
  const handleFileChange1 = (event) => {
    setSelectedFile1(event.target.files[0]);
  };

  const handleDownload = (filePath) => {
    const fileName = decodeURIComponent(filePath.split("/").pop());
    setLoadingDownload((prev) => ({ ...prev, [fileName]: true }));

    axios
      .get(`/api/${filePath}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      })
      .then((response) => {
        const contentDisposition = response.headers["content-disposition"];
        let resolvedFileName = fileName;
        if (contentDisposition) {
          const matches = contentDisposition.match(/filename="([^"]+)"/);
          if (matches?.length === 2) {
            resolvedFileName = matches[1];
          }
        }
        saveAs(new Blob([response.data]), resolvedFileName);
      })
      .catch((error) => {
        console.error("Download error:", error);
      })
      .finally(() => {
        setLoadingDownload((prev) => ({ ...prev, [fileName]: false }));
      });
  };

  const handleTeamFileDelete = (fileName, teamName) => {
    axios
      .delete(`/api/deleteTeamFile/${teamName}/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        // e.g., remove the file from the marketingfiles state
        if (response.status === 200) {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file could not be deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        const successMessage = document.createElement("div");
        successMessage.innerText = "file could not be deleted successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
        // Handle error
        console.error("Error deleting file:", error);
      });
  };

  const handleCottonTeamFileDelete = (fileName, teamName) => {
    axios
      .delete(`/api/deleteCottonTeamFile/${teamName}/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        // e.g., remove the file from the marketingfiles state
        if (response.status === 200) {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file could not be deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        const successMessage = document.createElement("div");
        successMessage.innerText = "file could not be deleted successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
        // Handle error
        console.error("Error deleting file:", error);
      });
  };

  useEffect(() => {
    if (selectedUser) {
      generateImageUrl();

      if (value === 0) {
        fetchTeamMembers();
        fetchApplicationTypeConfirmationN();
        fetchApplicationTypeConfirmation();
        fetchApplicationTypeConfirmation1();
      } else if (value === 1) {
        fetchCottonTeamMembers();
        fetchApplicationTypeConfirmationNCotton();
        fetchApplicationTypeConfirmationCotton();
        fetchApplicationTypeConfirmation1Cotton();
      }
    }
  }, [selectedUser, value]);

  const fetchApplicationTypeConfirmationN = () => {
    setApplicationType("");
    setIsApplicationTypeConfirmedN(false);
    axios
      .get("/api/getApplicationTypeConfirmation", {
        params: { teamName: selectedUser.teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setApplicationType(response.data.applicationType);
          setIsApplicationTypeConfirmedN(response.data.isConfirmed);
        } else {
          setApplicationType("");
          setIsApplicationTypeConfirmedN(false);
          console.error("Application type confirmation not found");
        }
      })
      .catch((error) => {
        setApplicationType("");
        setIsApplicationTypeConfirmedN(false);
        console.error("Error fetching application type confirmation:", error);
      });
  };

  const fetchApplicationTypeConfirmationNCotton = () => {
    setApplicationType("");
    setIsApplicationTypeConfirmedN(false);
    axios
      .get("/api/getCottonApplicationTypeConfirmation", {
        params: { teamName: selectedUser.teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setApplicationType(response.data.applicationType);
          setIsApplicationTypeConfirmedN(response.data.isConfirmed);
        } else {
          setApplicationType("");
          setIsApplicationTypeConfirmedN(false);
          console.error("Application type confirmation not found");
        }
      })
      .catch((error) => {
        setApplicationType("");
        setIsApplicationTypeConfirmedN(false);
        console.error("Error fetching application type confirmation:", error);
      });
  };

  const fetchApplicationTypeConfirmation = () => {
    setSelectedOption("");
    setIsApplicationTypeConfirmed(false);
    axios
      .get("/api/getIrrigationApplicationTypeConfirmation", {
        params: { teamName: selectedUser.teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setSelectedOption(response.data.applicationType);
          setIsApplicationTypeConfirmed(response.data.isConfirmed);
        } else {
          setSelectedOption("");
          setIsApplicationTypeConfirmed(false);
          console.error("Application type confirmation not found");
        }
      })
      .catch((error) => {
        setSelectedOption("");
        setIsApplicationTypeConfirmed(false);
        console.error("Error fetching application type confirmation:", error);
      });
  };

  const fetchApplicationTypeConfirmation1 = () => {
    setSoilMoistureSensor("");
    setIsApplicationTypeConfirmed1(false);
    axios
      .get("/api/getMoistureApplicationTypeConfirmation", {
        params: { teamName: selectedUser.teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setSoilMoistureSensor(response.data.applicationType);
          setIsApplicationTypeConfirmed1(response.data.isConfirmed);
        } else {
          setSoilMoistureSensor("");
          setIsApplicationTypeConfirmed1(false);
          console.error("Sensor type confirmation not found");
        }
      })
      .catch((error) => {
        setSoilMoistureSensor("");
        setIsApplicationTypeConfirmed1(false);
        console.error("Error fetching sensor type confirmation:", error);
      });
  };

  const fetchApplicationTypeConfirmationCotton = () => {
    setSelectedOption("");
    setIsApplicationTypeConfirmed(false);
    axios
      .get("/api/getIrrigationApplicationTypeConfirmationCotton", {
        params: { teamName: selectedUser.teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setSelectedOption(response.data.applicationType);
          setIsApplicationTypeConfirmed(response.data.isConfirmed);
        } else {
          setSelectedOption("");
          setIsApplicationTypeConfirmed(false);
          console.error("Application type confirmation not found");
        }
      })
      .catch((error) => {
        setSelectedOption("");
        setIsApplicationTypeConfirmed(false);
        console.error("Error fetching application type confirmation:", error);
      });
  };

  const fetchApplicationTypeConfirmation1Cotton = () => {
    setSoilMoistureSensor("");
    setIsApplicationTypeConfirmed1(false);
    axios
      .get("/api/getMoistureApplicationTypeConfirmationCotton", {
        params: { teamName: selectedUser.teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setSoilMoistureSensor(response.data.applicationType);
          setIsApplicationTypeConfirmed1(response.data.isConfirmed);
        } else {
          setSoilMoistureSensor("");
          setIsApplicationTypeConfirmed1(false);
          console.error("Sensor type confirmation not found");
        }
      })
      .catch((error) => {
        setSoilMoistureSensor("");
        setIsApplicationTypeConfirmed1(false);
        console.error("Error fetching sensor type confirmation:", error);
      });
  };

  const fetchProfileImage = () => {
    const crop = value === 0 ? "corn" : value === 1 ? "cotton" : "";
    const profileImageUrlEndpoint = `/api/getProfileImageUrl/${crop}/${selectedUser.teamName}`;

    fetch(profileImageUrlEndpoint, {
      headers: {
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      },
    })
      .then((response) => response.text()) // Assuming the response is plain text containing the image URL
      .then((imageUrl) => {
        // Backend returns 'uploads/2026/...' but static route is '/uploads'
        const correctedUrl = imageUrl.replace("uploads/2026", "/uploads/2026");
        setProfileImageUrl(correctedUrl);
      })
      .catch(() => {
        setProfileImageUrl(
          `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRooEnD32-UtBw55GBfDTxxUZApMhWWnRaoLw&usqp=CAU`,
        ); // Path to your generic image
      });
  };

  // Define the function to fetch team members
  const fetchTeamMembers = async () => {
    if (selectedUser) {
      setTeamMembers([]);
      const teamId = selectedUser.id; // Assuming selectedUser.id contains the ID of the team
      axios
        .post(
          "/api/cornTeamMembers",
          {
            id: teamId, // Access the team ID from cornuser[0]
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          },
        )
        .then((response) => {
          // Handle the fetched team members data, e.g., set it in state
          console.log(response.data);
          setTeamMembers(response.data);
        })

        .catch((error) => {
          setTeamMembers([]);
          console.error("Failed to fetch team members:", error);
          // Handle errors, for example, by showing an error message in the UI
        });
    }
  };

  // Call this function at the appropriate time, for example, when a team is selected
  // fetchTeamMembers();

  const generateImageUrl = () => {
    if (selectedUser) {
      // Determine the crop based on the value
      // const crop = value === 0 ? "corn" : value === 1 ? "cotton" : "";
      // const imageUrl = `/uploads/${crop}/${selectedUser.teamName}/profile.jpg`;
      // fetch(imageUrl)
      //   .then((response) => {
      //     if (response.ok) {
      //       setProfileImageUrl(imageUrl);
      //     } else {
      //       setProfileImageUrl("./profile.jpg"); // Path to your generic image
      //     }
      //   })
      //   .catch(() => {
      //     setProfileImageUrl("./profile.jpg"); // Path to your generic image
      //   });
      setProfileImageUrl(
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRooEnD32-UtBw55GBfDTxxUZApMhWWnRaoLw&usqp=CAU",
      );
      fetchProfileImage();
    }
  };
  // If either selectedUser or crop is not set, return a default image URL

  // Use the generateImageUrl function to set the imageUrl
  //const imageUrl = generateImageUrl();

  // Handler for file upload
  const handleteamFileUpload = (teamName) => {
    // const selectedFile = document.getElementById("defaultFileInput1").files[0];

    // Check if a file is selected

    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("teamName", teamName); // Assuming teamName is passed as a prop or from state
    formData.append("cropType", "corn"); // Assuming cropType is passed as a prop or from state

    axios
      .post("/api/upload", formData, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("File uploaded successfully:", response.data);
        // Handle successful upload here (e.g., clear the selection, display a message)
        const successMessage = document.createElement("div");
        successMessage.innerText = "Team file uploaded successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input
        document.getElementById("defaultFileInput1").value = "";

        // Refresh the file list to show the newly uploaded file
        fetchFiles(teamName);

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        // Handle errors here (e.g., display an error message)
      });
  };

  const handleteamFileUpload1 = (teamName) => {
    // const selectedFile = document.getElementById("defaultFileInput1").files[0];

    // Check if a file is selected

    if (!selectedFile1) {
      alert("Please select a file to upload.");
      return;
    }

    const formData1 = new FormData();
    formData1.append("file", selectedFile1);
    formData1.append("teamName", teamName); // Assuming teamName is passed as a prop or from state
    formData1.append("cropType", "cotton"); // Assuming cropType is passed as a prop or from state

    axios
      .post("/api/upload", formData1, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("File uploaded successfully:", response.data);
        // Handle successful upload here (e.g., clear the selection, display a message)
        const successMessage = document.createElement("div");
        successMessage.innerText = "team file uploaded successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input
        document.getElementById("defaultFileInput2").value = "";

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        // Handle errors here (e.g., display an error message)
      });
  };

  const handleinsuranceDelete = (fileName) => {
    axios
      .delete(`/api/deleteinsuranceFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        // e.g., remove the file from the marketingfiles state
        if (response.status === 200) {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file could not be deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        const successMessage = document.createElement("div");
        successMessage.innerText = "file could not be deleted successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
        // Handle error
        console.error("Error deleting file:", error);
      });
  };

  const handlemarketingDelete = (fileName) => {
    axios
      .delete(`/api/deletemarketingFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        // e.g., remove the file from the marketingfiles state
        if (response.status === 200) {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file could not be deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        const successMessage = document.createElement("div");
        successMessage.innerText = "file could not be deleted successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
        // Handle error
        console.error("Error deleting file:", error);
      });
  };

  const handledefaultDelete = (fileName) => {
    axios
      .delete(`/api/deletedefaultFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        // e.g., remove the file from the marketingfiles state
        if (response.status === 200) {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file could not be deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        const successMessage = document.createElement("div");
        successMessage.innerText = "file could not be deleted successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
        // Handle error
        console.error("Error deleting file:", error);
      });
  };

  const handlecottoninsuranceDelete = (fileName) => {
    axios
      .delete(`/api/deletecottoninsuranceFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        // e.g., remove the file from the marketingfiles state
        if (response.status === 200) {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file could not be deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        const successMessage = document.createElement("div");
        successMessage.innerText = "file could not be deleted successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
        // Handle error
        console.error("Error deleting file:", error);
      });
  };

  const handlecottonmarketingDelete = (fileName) => {
    axios
      .delete(`/api/deletecottonmarketingFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        // e.g., remove the file from the marketingfiles state
        if (response.status === 200) {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file could not be deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        const successMessage = document.createElement("div");
        successMessage.innerText = "file could not be deleted successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
        // Handle error
        console.error("Error deleting file:", error);
      });
  };

  const handlecottondefaultDelete = (fileName) => {
    axios
      .delete(`/api/deletecottondefaultFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        // e.g., remove the file from the marketingfiles state
        if (response.status === 200) {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          const successMessage = document.createElement("div");
          successMessage.innerText = "file could not be deleted successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        const successMessage = document.createElement("div");
        successMessage.innerText = "file could not be deleted successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
        // Handle error
        console.error("Error deleting file:", error);
      });
  };

  useEffect(() => {
    // Fetch the list of files when the component mounts
    axios
      .get("/api/listdefaultFiles", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setDefaultFiles(response.data.files);
        } else {
          setDefaultFiles([]);
          console.error("Failed to fetch files from the backend");
        }
      })
      .catch((error) => {
        setDefaultFiles([]);
        console.error("Error fetching files:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch the list of files when the component mounts
    axios
      .get("/api/listInsuranceFiles", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setInsuranceFiles(response.data.files);
        } else {
          setInsuranceFiles([]);
          console.error("Failed to fetch files from the backend");
        }
      })
      .catch((error) => {
        setInsuranceFiles([]);
        console.error("Error fetching files:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch the list of files when the component mounts
    axios
      .get("/api/listMarketingFiles", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setMarketingFiles(response.data.files);
        } else {
          setMarketingFiles([]);
          console.error("Failed to fetch files from the backend");
        }
      })
      .catch((error) => {
        setMarketingFiles([]);
        console.error("Error fetching files:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch the list of files when the component mounts
    axios
      .get("/api/listCottonDefaultFiles", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setCottonDefaultFiles(response.data.files);
        } else {
          console.error("Failed to fetch files from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching files:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch the list of files when the component mounts
    axios
      .get("/api/listCottonInsuranceFiles", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setCottonInsuranceFiles(response.data.files);
        } else {
          console.error("Failed to fetch files from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching files:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch the list of files when the component mounts
    axios
      .get("/api/listCottonMarketingFiles", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setCottonMarketingFiles(response.data.files);
        } else {
          console.error("Failed to fetch files from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching files:", error);
      });
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectedUser(null);
  };

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setValue1(newValue);
  };

  const [teamfiles, setTeamFiles] = useState([]);

  const fetchFiles = async (teamName) => {
    setTeamFiles([]);
    try {
      const response = await axios.get(`/api/listTeamFiles/${teamName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      });
      setTeamFiles(response.data.files);
    } catch (error) {
      setTeamFiles([]);
      console.error("Error fetching files:", error);
      // Handle error appropriately
    }
  };

  const [cottonteamfiles, setCottonTeamFiles] = useState([]);

  const fetchCottonFiles = async (teamName) => {
    try {
      setCottonTeamFiles([]);
      const response = await axios.get(`/api/listCottonTeamFiles/${teamName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      });
      setCottonTeamFiles(response.data.files);
    } catch (error) {
      setCottonTeamFiles([]);
      console.error("Error fetching files:", error);
      // Handle error appropriately
    }
  };

  const handleUserClick = (user) => {
    setSelectedUser(user);
    fetchFiles(user.teamName);
  };

  const handleUserClick1 = (user) => {
    setSelectedUser(user);
    fetchCottonFiles(user.teamName);
  };

  const handleDeleteNitrogenApplication = (appId) => {
    axios
      .delete(`/api/deletenitrogenApplication/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          fetchDataFromBackend();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        console.error("Error deleting the application:", error);
      });
  };

  const handleDeleteNitrogenApplication1 = (appId) => {
    axios
      .delete(`/api/deletecottonnitrogenApplication/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          fetchNitrogenCottonDataFromBackend();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        console.error("Error deleting the application:", error);
      });
  };

  const handleChangeApplied = (appId) => {
    // Make a POST request to your Express.js route to update the "applied" field
    axios
      .post(
        `/api/updateApplied/${appId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchIrrigationData();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        // Handle any errors (e.g., show an error message)
        console.error("Error updating applied field:", error);
      });
  };

  const handleChangeApplied1 = (appId) => {
    // Make a POST request to your Express.js route to update the "applied" field
    axios
      .post(
        `/api/updateCottonApplied/${appId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchCottonIrrigationData();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        // Handle any errors (e.g., show an error message)
        console.error("Error updating applied field:", error);
      });
  };

  const handleNitrogenChangeApplied = (appId) => {
    // Make a POST request to your Express.js route to update the "applied" field
    axios
      .post(
        `/api/updateNitrogenApplied/${appId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchDataFromBackend();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        // Handle any errors (e.g., show an error message)
        console.error("Error updating applied field:", error);
      });
  };

  const handleNitrogenChangeApplied1 = (appId) => {
    // Make a POST request to your Express.js route to update the "applied" field
    axios
      .post(
        `/api/updateCottonNitrogenApplied/${appId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchNitrogenCottonDataFromBackend();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        // Handle any errors (e.g., show an error message)
        console.error("Error updating applied field:", error);
      });
  };

  useEffect(() => {
    // Fetch the submitted hybrid forms data from your server
    // You can make an Axios GET request to your API endpoint
    axios
      .get("/api/getAllCottonSubmittedHybridForms", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        setSubmittedCottonHybridForms(response.data);
      })
      .catch((error) => {
        console.error("Error fetching submitted hybrid forms data:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch the submitted hybrid forms data from your server
    // You can make an Axios GET request to your API endpoint
    axios
      .get("/api/cottonFetchAllGrowthRegulation", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setGrowthRegulationCotton(response.data);
        } else {
          console.error(
            "Failed to fetch growth regulation data from the backend",
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching submitted hybrid forms data:", error);
      });
  }, []);

  function handleCottonInsuranceFileUpload() {
    // Get the selected insurance file from the file input
    const insuranceFile = document.getElementById("insuranceFileInput1")
      .files[0];

    // Check if a file is selected
    if (!insuranceFile) {
      alert("Please select an insurance file.");
      return;
    }

    // Set loading state
    setUploadingFile("cottonInsurance");

    // Create a FormData object to send the insurance file
    const insuranceFormData = new FormData();
    insuranceFormData.append("insuranceFile", insuranceFile);

    // Send a POST request to upload the insurance file
    axios
      .post("/api/uploadCottonInsuranceFile", insuranceFormData, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("Insurance file uploaded successfully");
        const successMessage = document.createElement("div");
        successMessage.innerText = "Insurance file uploaded successfully";
        document.getElementById("uploadStatus").appendChild(successMessage);

        // Remove the selected file from the input
        document.getElementById("insuranceFileInput1").value = "";

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
      })
      .catch((error) => {
        console.error("Error uploading insurance file:", error);
        alert("Error uploading insurance file. Please try again.");
      })
      .finally(() => {
        // Clear loading state
        setUploadingFile(null);
      });
  }

  // Function to handle marketing options file upload
  function handleCottonMarketingOptionsFileUpload() {
    // Get the selected marketing options file from the file input
    const marketingOptionsFile = document.getElementById(
      "marketingOptionsFileInput1",
    ).files[0];

    // Check if a file is selected
    if (!marketingOptionsFile) {
      alert("Please select a marketing options file.");
      return;
    }

    // Set loading state
    setUploadingFile("cottonMarketing");

    // Create a FormData object to send the marketing options file
    const marketingOptionsFormData = new FormData();
    marketingOptionsFormData.append(
      "marketingOptionsFile",
      marketingOptionsFile,
    );

    // Send a POST request to upload the marketing options file
    axios
      .post("/api/uploadCottonMarketingOptionsFile", marketingOptionsFormData, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("Cotton Marketing options file uploaded successfully");
          const successMessage = document.createElement("div");
          successMessage.innerText =
            "Marketing options file uploaded successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input
          document.getElementById("marketingOptionsFileInput1").value = "";

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          console.error("Error uploading marketing options file");
        }
      })
      .catch((error) => {
        console.error("Error uploading marketing options file:", error);
        alert("Error uploading marketing options file. Please try again.");
      })
      .finally(() => {
        // Clear loading state
        setUploadingFile(null);
      });
  }

  // Function to handle marketing options file upload
  function handledefaultFileUpload() {
    // Get the selected marketing options file from the file input
    const cottondefaultFile = document.getElementById("defaultCottonFileInput")
      .files[0];

    // Check if a file is selected
    if (!cottondefaultFile) {
      alert("Please select a general file.");
      return;
    }

    // Create a FormData object to send the marketing options file
    const defaultData = new FormData();
    defaultData.append("cottondefaultFile", cottondefaultFile);

    // Send a POST request to upload the marketing options file
    axios
      .post("/api/uploadCottonDefaultFile", defaultData, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("cotton default file uploaded successfully");
          const successMessage = document.createElement("div");
          successMessage.innerText = "default file uploaded successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input
          document.getElementById("defaultCottonFileInput").value = "";

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } else {
          console.error("Error uploading cotton default file");
        }
      })
      .catch((error) => {
        console.error("Error uploading cotton default file:", error);
      });
  }

  function handlecorndefaultFileUpload() {
    // Get the selected marketing options file from the file input
    // const defaultFile = document.getElementById("defaultFileInput").files[0];

    // Check if a file is selected
    if (!selectedFiled) {
      alert("Please select a general file.");
      return;
    }

    // Create a FormData object to send the marketing options file
    const defaultData = new FormData();
    defaultData.append("file", selectedFiled);

    // Send a POST request to upload the marketing options file
    axios
      .post("/api/uploadDefaultFile", defaultData, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("corn default file uploaded successfully");
          const successMessage = document.createElement("div");
          successMessage.innerText = "default file uploaded successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input
          document.getElementById("defaultFileInput").value = "";

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        console.error("Error uploading corn default file:", error);
      });
  }

  const handleDeleteApplication = (appId) => {
    axios
      .delete(`/api/deleteirrigationApplication/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchIrrigationData();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        console.error("Error deleting the application:", error);
      });
  };

  const handleDeleteApplication1 = (appId) => {
    axios
      .delete(`/api/deletecottonirrigationApplication/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchCottonIrrigationData();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        console.error("Error deleting the application:", error);
      });
  };

  function handleFileUpload() {
    // Get the selected files from the file inputs
    const insuranceFile =
      document.getElementById("insuranceFileInput").files[0];
    const marketingOptionsFile = document.getElementById(
      "marketingOptionsFileInput",
    ).files[0];

    // Check if files are selected
    if (!insuranceFile || !marketingOptionsFile) {
      alert("Please select both insurance and marketing options files.");
      return;
    }

    // Create FormData objects to send the files
    const insuranceFormData = new FormData();
    insuranceFormData.append("insuranceFile", insuranceFile);

    const marketingOptionsFormData = new FormData();
    marketingOptionsFormData.append(
      "marketingOptionsFile",
      marketingOptionsFile,
    );

    // Send POST requests to upload the files (you can use Axios or other libraries)
    // Example using fetch:
    fetch(
      "/api/uploadInsuranceFile",
      {
        method: "POST",
        body: insuranceFormData,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      },
    )
      .then((response) => {
        if (response.ok) {
          console.log("Insurance file uploaded successfully");
        } else {
          console.error("Error uploading insurance file");
        }
      })
      .catch((error) => {
        console.error("Error uploading insurance file:", error);
      });

    fetch("/api/uploadMarketingOptionsFile", {
      method: "POST",
      body: marketingOptionsFormData,
    })
      .then((response) => {
        if (response.ok) {
          console.log("Marketing options file uploaded successfully");
        } else {
          console.error("Error uploading marketing options file");
        }
      })
      .catch((error) => {
        console.error("Error uploading marketing options file:", error);
      });
  }

  // Function to handle insurance file upload
  const handleInsuranceFileUpload = () => {
    // Get the selected insurance file from the file input
    // const insuranceFile =
    //   document.getElementById("insuranceFileInput").files[0];
    // Check if a file is selected
    if (!selectedFilei) {
      alert("Please select an insurance file.");
      return;
    }

    // Set loading state
    setUploadingFile("insurance");

    // Create a FormData object to send the insurance file
    const insuranceFormData = new FormData();
    insuranceFormData.append("file", selectedFilei);

    // Send a POST request to upload the insurance file
    axios
      .post("/api/uploadInsuranceFile", insuranceFormData, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("Insurance file uploaded successfully");
          const successMessage = document.createElement("div");
          successMessage.innerText = "Insurance file uploaded successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input
          document.getElementById("insuranceFileInput").value = "";
          setSelectedFilei(null);

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        console.error("Error uploading insurance file:", error);
        alert("Error uploading insurance file. Please try again.");
      })
      .finally(() => {
        // Clear loading state
        setUploadingFile(null);
      });
  };

  // Function to handle marketing options file upload
  function handleMarketingOptionsFileUpload() {
    // Get the selected marketing options file from the file input
    // const marketingOptionsFile = document.getElementById(
    //   "marketingOptionsFileInput"
    // ).files[0];

    // Check if a file is selected
    if (!selectedFilem) {
      alert("Please select a marketing options file.");
      return;
    }

    // Set loading state
    setUploadingFile("marketing");

    // Create a FormData object to send the marketing options file
    const marketingOptionsFormData = new FormData();
    marketingOptionsFormData.append("file", selectedFilem);
    axios
      .post("/api/uploadMarketingOptionsFile", marketingOptionsFormData, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      // Send a POST request to upload the marketing options file

      .then((response) => {
        if (response.status === 200) {
          console.log("Marketing options file uploaded successfully");
          const successMessage = document.createElement("div");
          successMessage.innerText =
            "Marketing options file uploaded successfully";
          document.getElementById("uploadStatus").appendChild(successMessage);

          // Remove the selected file from the input
          document.getElementById("marketingOptionsFileInput").value = "";
          setSelectedFilem(null);

          // Remove the success message after 3 seconds (3000 milliseconds)
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        }
      })
      .catch((error) => {
        console.error("Error uploading marketing options file:", error);
        alert("Error uploading marketing options file. Please try again.");
      })
      .finally(() => {
        // Clear loading state
        setUploadingFile(null);
      });
  }

  useEffect(() => {
    // Fetch users for the Corn crop from the API
    axios
      .get("/api/get_corn_users", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        setCornUsers(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Corn users data:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch users for the Cotton crop from the API (changed to cotton)
    axios
      .get("/api/get_cotton_users", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        setCottonUsers(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Cotton users data:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch the submitted hybrid forms data from your server
    // You can make an Axios GET request to your API endpoint
    axios
      .get("/api/getAllCornSubmittedHybridForms", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        setSubmittedHybridForms(response.data);
      })
      .catch((error) => {
        console.error("Error fetching submitted hybrid forms data:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch the submitted forms data for the logged-in user
    const fetchcornSeedingSubmittedForms = async () => {
      try {
        const response = await axios.get(
          "/api/getAllCornseedingForms",
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          },
          // Send username as part of the request body
        );

        if (response.status === 200) {
          // Update the state with the fetched data
          setseedingSubmittedForms(response.data);
        } else {
          console.error("Failed to fetch submitted forms data");
        }
      } catch (error) {
        console.error("Error fetching submitted forms data:", error);
      }
    };

    //Call the fetch function when the component mounts
    fetchcornSeedingSubmittedForms();
  }, []);

  useEffect(() => {
    // Fetch the submitted forms data for the logged-in user
    const fetchcottonSeedingSubmittedForms = async () => {
      try {
        const response = await axios.get(
          "/api/getAllCottonseedingForms",
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          },
          // Send username as part of the request body
        );

        if (response.status === 200) {
          // Update the state with the fetched data
          setseedingcottonSubmittedForms(response.data);
        } else {
          console.error("Failed to fetch submitted forms data");
        }
      } catch (error) {
        console.error("Error fetching submitted forms data:", error);
      }
    };

    // Call the fetch function when the component mounts
    fetchcottonSeedingSubmittedForms();
  }, []);

  useEffect(() => {
    // Fetch data from the backend when the component mounts
    fetchDataFromBackend();
  }, []); // Fetch data whenever applicationType changes

  const fetchDataFromBackend = () => {
    // Make an API request to fetch data from the backend based on the application type
    axios
      .get("/api/fetchAllNitrogenManagementData", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Set the retrieved data to the state variable
          console.log(response.data);
          setNitrogenTableData(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    // Fetch data from the backend when the component mounts
    fetchNitrogenCottonDataFromBackend();
  }, []);

  const fetchNitrogenCottonDataFromBackend = () => {
    // Make an API request to fetch data from the backend based on the application type
    axios
      .get("/api/cottonfetchAllNitrogenManagementData", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Set the retrieved data to the state variable
          console.log(response.data);
          setNitrogenCottonTableData(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const fetchIrrigationData = () => {
    axios
      .get("/api/fetchAllSoilMoistureSensorData", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          // Handle the successful response and update the state
          setIrrigationApplications(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
      });
  };

  //Call the fetchData function when the component mounts
  useEffect(() => {
    fetchIrrigationData();
  }, []);

  const fetchCottonIrrigationData = () => {
    axios
      .get("/api/cottonfetchAllSoilMoistureSensorData", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        // Handle the successful response and update the state
        setIrrigationCottonApplications(response.data);
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
      });
  };

  // Call the fetchData function when the component mounts
  useEffect(() => {
    fetchCottonIrrigationData();
  }, []);

  const fetchCottonTeamMembers = async () => {
    setCottonTeamMembers([]);
    if (selectedUser && selectedUser.cropType === "cotton") {
      const teamId = selectedUser.id; // Assuming selectedUser.id contains the ID of the team
      axios
        .post(
          "/api/cottonTeamMembers",
          {
            id: teamId, // Access the team ID from cornuser[0]
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          },
        )
        .then((response) => {
          // Handle the fetched team members data, e.g., set it in state
          console.log(response.data);
          setCottonTeamMembers(response.data);
        })

        .catch((error) => {
          setCottonTeamMembers([]);
          console.error("Failed to fetch team members:", error);
          // Handle errors, for example, by showing an error message in the UI
        });
    }
  };

  const fetchInsuranceSelectionData = () => {
    axios
      .get("/api/getAllInsuranceSelectionForms", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setInsuranceFormData(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  // Fetch existing insurance selection data for the user when the component mounts
  useEffect(() => {
    fetchInsuranceSelectionData();
  }, []);

  const fetchInsuranceCottonSelectionData = () => {
    axios
      .get("/api/cottongetAllInsuranceSelectionForms", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setInsuranceCottonFormData(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  // Fetch existing insurance selection data for the user when the component mounts
  useEffect(() => {
    fetchInsuranceCottonSelectionData();
  }, []);

  const fetchMarketingDataFromBackend = () => {
    // Make an API request to fetch data from the backend
    axios
      .get("/api/fetchAllMarketingOptions", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        if (response.status === 200) {
          // Set the retrieved data to the state variable
          setMarketingOptions(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    // Fetch data from the backend when the component mounts
    fetchMarketingDataFromBackend();
  }, []);

  const fetchMarketingCottonDataFromBackend = () => {
    // Make an API request to fetch data from the backend
    axios
      .get("/api/cottonfetchAllMarketingOptions", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        if (response.status === 200) {
          // Set the retrieved data to the state variable
          setMarketingCottonOptions(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    // Fetch data from the backend when the component mounts
    fetchMarketingCottonDataFromBackend();
  }, []);

  const tabLabels = [
    "User Info",
    "Hybrid",
    "Seeding",
    "Nitrogen Mgmnt",
    "Irrigation Mgmnt",
    "Insurance",
    "Marketing",
    "File Mgmnt",
  ];

  const tabLabelsCotton = [
    "User Info",
    "Hybrid",
    "Seeding",
    "Nitrogen Mgmnt",
    "Irrigation Mgmnt",
    "Insurance",
    "Growth Regulator",
    "Marketing",
    "File Mgmnt",
  ];

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleDeleteCottonUser = () => {
    // API call to delete the user

    const isFirstConfirmed = window.confirm(
      "Are you sure you want to delete this user?",
    );
    if (!isFirstConfirmed) return;

    // Second confirmation
    const isSecondConfirmed = window.confirm(
      "This action is irreversible. Are you absolutely sure?",
    );
    if (!isSecondConfirmed) return;
    axios
      .delete(`/api/deleteCottonUser/${selectedUser.id}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("User deleted successfully:", response);
        // Handle successful deletion (e.g., update state, show notification)
        setSuccessMessage("User deleted successfully.");
        setTimeout(() => {
          window.location.reload();
        }, 10000);
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
        // Handle error (e.g., show error message)
        setErrorMessage("Failed to delete user.");
        setTimeout(() => {
          window.location.reload();
        }, 20000);
      });
  };

  const handleDeleteCornUser = () => {
    // API call to delete the user
    const isFirstConfirmed = window.confirm(
      "Are you sure you want to delete this user?",
    );
    if (!isFirstConfirmed) return;

    // Second confirmation
    const isSecondConfirmed = window.confirm(
      "This action is irreversible. Are you absolutely sure?",
    );
    if (!isSecondConfirmed) return;
    axios
      .delete(`/api/deleteCornUser/${selectedUser.id}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("User deleted successfully:", response);
        // Handle successful deletion (e.g., update state, show notification)
        setSuccessMessage("User deleted successfully.");
        setTimeout(() => {
          window.location.reload();
        }, 10000);
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
        // Handle error (e.g., show error message)
        setErrorMessage("Failed to delete user.");
        setTimeout(() => {
          window.location.reload();
        }, 20000);
      });
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("token");
    const decoded = jwtDecode(accessToken);
    const adminId = decoded.id;
    // Replace URL with your API endpoint
    axios
      .get(`/api/getAdminCrops?adminId=${adminId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAdminCrops(response.data.crops);
        console.log("Admin Crops");
        console.log(adminId);
        console.log(response.data.crops);
      })
      .catch((error) => {
        console.error("Error fetching admin crops:", error);
      });
  }, []);

  const showCorn = adminCrops.includes("Corn");
  const showCotton = adminCrops.includes("Cotton");
  const activeCropType =
    showCorn && !showCotton
      ? "corn"
      : !showCorn && showCotton
        ? "cotton"
        : value === 1
          ? "cotton"
          : "corn";
  const username = localStorage.getItem("username");

  useEffect(() => {
    localStorage.setItem("activeAdminCrop", activeCropType);
  }, [activeCropType]);

  const handleProfileClick = () => {
    navigate("/adminprofile");
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  const handleManageFiles = () => {
    setShowFileManagement(true);
  };

  const handleCloseFileManagement = () => {
    setShowFileManagement(false);
  };

  const handleCloseContractPrices = () => {
    setShowMarketingPrices(false);
  };

  const handleMarketingPricesClick = () => {
    setShowMarketingPrices(true);
  };

  if (showMarketingPrices) {
    return (
      <div style={{ marginLeft: "20px" }}>
        <Button onClick={handleCloseContractPrices}>Back to Main Page</Button>
        {showCorn && value === 0 ? <CornContractPrices /> : <ContractPrices />}
      </div>
    );
  }

  if (showFileManagement) {
    if (showCorn) {
      return (
        <div>
          <Button
            onClick={handleCloseFileManagement}
            variant="contained"
            sx={{ mb: 2 }}
          >
            Back to Main Page
          </Button>

          <Card elevation={3} sx={{ mb: 3, p: 2 }}>
            <CardContent>
              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                sx={{ display: "flex", alignItems: "center", mb: 2 }}
              >
                <CloudUpload sx={{ mr: 1 }} /> Upload Files
              </Typography>
              <Divider sx={{ mb: 3 }} />

              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Insurance Selection
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  Choose a file that contains details for teams to check
                  insurance options
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<InsertDriveFile />}
                  >
                    Choose File
                    <input
                      type="file"
                      id="insuranceFileInput"
                      onChange={handleInsuranceFileChange}
                      hidden
                    />
                  </Button>
                  {selectedFilei && (
                    <Chip
                      label={selectedFilei.name}
                      onDelete={() => {
                        setSelectedFilei(null);
                        document.getElementById("insuranceFileInput").value =
                          "";
                      }}
                      color="primary"
                      variant="outlined"
                    />
                  )}
                  <Button
                    variant="contained"
                    onClick={handleInsuranceFileUpload}
                    disabled={!selectedFilei || uploadingFile === "insurance"}
                    startIcon={
                      uploadingFile === "insurance" ? (
                        <CircularProgress size={20} />
                      ) : (
                        <CloudUpload />
                      )
                    }
                  >
                    {uploadingFile === "insurance"
                      ? "Uploading..."
                      : "Upload Insurance"}
                  </Button>
                </Box>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Marketing Options
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  Choose a file that contains details for teams to check
                  marketing options
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<InsertDriveFile />}
                  >
                    Choose File
                    <input
                      type="file"
                      id="marketingOptionsFileInput"
                      onChange={handleMarketingFileChange}
                      hidden
                    />
                  </Button>
                  {selectedFilem && (
                    <Chip
                      label={selectedFilem.name}
                      onDelete={() => {
                        setSelectedFilem(null);
                        document.getElementById(
                          "marketingOptionsFileInput",
                        ).value = "";
                      }}
                      color="primary"
                      variant="outlined"
                    />
                  )}
                  <Button
                    variant="contained"
                    onClick={handleMarketingOptionsFileUpload}
                    disabled={!selectedFilem || uploadingFile === "marketing"}
                    startIcon={
                      uploadingFile === "marketing" ? (
                        <CircularProgress size={20} />
                      ) : (
                        <CloudUpload />
                      )
                    }
                  >
                    {uploadingFile === "marketing"
                      ? "Uploading..."
                      : "Upload Marketing"}
                  </Button>
                </Box>
              </Box>

              <Box>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  General Files
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  Choose a file to upload for all teams
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<InsertDriveFile />}
                  >
                    Choose File
                    <input
                      type="file"
                      id="defaultFileInput"
                      onChange={handleDefaultFileChange}
                      hidden
                    />
                  </Button>
                  {selectedFiled && (
                    <Chip
                      label={selectedFiled.name}
                      onDelete={() => {
                        setSelectedFiled(null);
                        document.getElementById("defaultFileInput").value = "";
                      }}
                      color="primary"
                      variant="outlined"
                    />
                  )}
                  <Button
                    variant="contained"
                    onClick={handlecorndefaultFileUpload}
                    disabled={!selectedFiled || uploadingFile === "default"}
                    startIcon={
                      uploadingFile === "default" ? (
                        <CircularProgress size={20} />
                      ) : (
                        <CloudUpload />
                      )
                    }
                  >
                    {uploadingFile === "default"
                      ? "Uploading..."
                      : "Upload Default"}
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <Container>
            <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Description sx={{ mr: 1 }} /> Corn Files
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Typography variant="h6" gutterBottom color="primary">
                Default Files:
              </Typography>
              <List>
                {defaultfiles
                  .filter(
                    (fileName) =>
                      fileName !== "metadata.json" && fileName !== "Thumbs.db",
                  )
                  .map((fileName, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        mb: 1,
                        "&:hover": { bgcolor: "#f5f5f5" },
                      }}
                    >
                      <InsertDriveFile sx={{ mr: 2, color: "#1976d2" }} />
                      <ListItemText primary={fileName} />
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={!!loadingDownload[fileName]}
                        onClick={() =>
                          handleDownload(`downloadDefaultFile/${fileName}`)
                        }
                        startIcon={
                          loadingDownload[fileName] ? null : <GetApp />
                        }
                        sx={{ mr: 1 }}
                      >
                        {loadingDownload[fileName] ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Download"
                        )}
                      </Button>
                      <IconButton
                        color="error"
                        onClick={() => handledefaultDelete(fileName)}
                        size="small"
                      >
                        <Delete />
                      </IconButton>
                    </ListItem>
                  ))}
              </List>

              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                sx={{ mt: 3 }}
              >
                Insurance Files:
              </Typography>
              <List>
                {insurancefiles
                  .filter(
                    (fileName) =>
                      fileName !== "metadata.json" && fileName !== "Thumbs.db",
                  )
                  .map((fileName, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        mb: 1,
                        "&:hover": { bgcolor: "#f5f5f5" },
                      }}
                    >
                      <InsertDriveFile sx={{ mr: 2, color: "#1976d2" }} />
                      <ListItemText primary={fileName} />
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={!!loadingDownload[fileName]}
                        onClick={() =>
                          handleDownload(`downloadInsuranceFile/${fileName}`)
                        }
                        startIcon={
                          loadingDownload[fileName] ? null : <GetApp />
                        }
                        sx={{ mr: 1 }}
                      >
                        {loadingDownload[fileName] ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Download"
                        )}
                      </Button>
                      <IconButton
                        color="error"
                        onClick={() => handleinsuranceDelete(fileName)}
                        size="small"
                      >
                        <Delete />
                      </IconButton>
                    </ListItem>
                  ))}
              </List>

              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                sx={{ mt: 3 }}
              >
                Marketing Files:
              </Typography>
              <List>
                {marketingfiles
                  .filter(
                    (fileName) =>
                      fileName !== "metadata.json" && fileName !== "Thumbs.db",
                  )
                  .map((fileName, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        mb: 1,
                        "&:hover": { bgcolor: "#f5f5f5" },
                      }}
                    >
                      <InsertDriveFile sx={{ mr: 2, color: "#1976d2" }} />
                      <ListItemText primary={fileName} />
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={!!loadingDownload[fileName]}
                        onClick={() =>
                          handleDownload(`downloadMarketingFile/${fileName}`)
                        }
                        startIcon={
                          loadingDownload[fileName] ? null : <GetApp />
                        }
                        sx={{ mr: 1 }}
                      >
                        {loadingDownload[fileName] ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Download"
                        )}
                      </Button>
                      <IconButton
                        color="error"
                        onClick={() => handlemarketingDelete(fileName)}
                        size="small"
                      >
                        <Delete />
                      </IconButton>
                    </ListItem>
                  ))}
              </List>
            </Paper>
          </Container>
        </div>
      );
    } else if (showCotton) {
      // Cotton tab is selected
      return (
        <div>
          <Button
            onClick={handleCloseFileManagement}
            variant="contained"
            sx={{ mb: 2 }}
          >
            Back to Main Page
          </Button>

          <Card elevation={3} sx={{ mb: 3, p: 2 }}>
            <CardContent>
              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                sx={{ display: "flex", alignItems: "center", mb: 2 }}
              >
                <CloudUpload sx={{ mr: 1 }} /> Upload Files
              </Typography>
              <Divider sx={{ mb: 3 }} />

              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Insurance Selection
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  Choose a file that contains details for teams to check
                  insurance options
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<InsertDriveFile />}
                  >
                    Choose File
                    <input
                      type="file"
                      id="insuranceFileInput1"
                      onChange={(e) => setSelectedFilei(e.target.files[0])}
                      hidden
                    />
                  </Button>
                  {selectedFilei && (
                    <Chip
                      label={selectedFilei.name}
                      onDelete={() => {
                        setSelectedFilei(null);
                        document.getElementById("insuranceFileInput1").value =
                          "";
                      }}
                      color="primary"
                      variant="outlined"
                    />
                  )}
                  <Button
                    variant="contained"
                    onClick={handleCottonInsuranceFileUpload}
                    disabled={uploadingFile === "cottonInsurance"}
                    startIcon={
                      uploadingFile === "cottonInsurance" ? (
                        <CircularProgress size={20} />
                      ) : (
                        <CloudUpload />
                      )
                    }
                  >
                    {uploadingFile === "cottonInsurance"
                      ? "Uploading..."
                      : "Upload Insurance"}
                  </Button>
                </Box>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Marketing Options
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  Choose a file that contains details for teams to check
                  marketing options
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<InsertDriveFile />}
                  >
                    Choose File
                    <input
                      type="file"
                      id="marketingOptionsFileInput1"
                      onChange={(e) => setSelectedFilem(e.target.files[0])}
                      hidden
                    />
                  </Button>
                  {selectedFilem && (
                    <Chip
                      label={selectedFilem.name}
                      onDelete={() => {
                        setSelectedFilem(null);
                        document.getElementById(
                          "marketingOptionsFileInput1",
                        ).value = "";
                      }}
                      color="primary"
                      variant="outlined"
                    />
                  )}
                  <Button
                    variant="contained"
                    onClick={handleCottonMarketingOptionsFileUpload}
                    disabled={uploadingFile === "cottonMarketing"}
                    startIcon={
                      uploadingFile === "cottonMarketing" ? (
                        <CircularProgress size={20} />
                      ) : (
                        <CloudUpload />
                      )
                    }
                  >
                    {uploadingFile === "cottonMarketing"
                      ? "Uploading..."
                      : "Upload Marketing"}
                  </Button>
                </Box>
              </Box>

              <Box>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  General Files
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  Choose a file to upload for all teams
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<InsertDriveFile />}
                  >
                    Choose File
                    <input
                      type="file"
                      id="defaultCottonFileInput"
                      onChange={(e) => setSelectedFiled(e.target.files[0])}
                      hidden
                    />
                  </Button>
                  {selectedFiled && (
                    <Chip
                      label={selectedFiled.name}
                      onDelete={() => {
                        setSelectedFiled(null);
                        document.getElementById(
                          "defaultCottonFileInput",
                        ).value = "";
                      }}
                      color="primary"
                      variant="outlined"
                    />
                  )}
                  <Button
                    variant="contained"
                    onClick={handledefaultFileUpload}
                    disabled={uploadingFile === "cottonDefault"}
                    startIcon={
                      uploadingFile === "cottonDefault" ? (
                        <CircularProgress size={20} />
                      ) : (
                        <CloudUpload />
                      )
                    }
                  >
                    {uploadingFile === "cottonDefault"
                      ? "Uploading..."
                      : "Upload Default"}
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <Container>
            <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Description sx={{ mr: 1 }} /> Cotton Files
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Typography variant="h6" gutterBottom color="primary">
                Default Files:
              </Typography>
              <List>
                {cottondefaultfiles
                  .filter(
                    (fileName) =>
                      fileName !== "metadata.json" && fileName !== "Thumbs.db",
                  )
                  .map((fileName, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        mb: 1,
                        "&:hover": { bgcolor: "#f5f5f5" },
                      }}
                    >
                      <InsertDriveFile sx={{ mr: 2, color: "#1976d2" }} />
                      <ListItemText primary={fileName} />
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={!!loadingDownload[fileName]}
                        onClick={() =>
                          handleDownload(
                            `downloadDefaultCottonFile/${fileName}`,
                          )
                        }
                        startIcon={
                          loadingDownload[fileName] ? null : <GetApp />
                        }
                        sx={{ mr: 1 }}
                      >
                        {loadingDownload[fileName] ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Download"
                        )}
                      </Button>
                      <IconButton
                        color="error"
                        onClick={() => handlecottondefaultDelete(fileName)}
                        size="small"
                      >
                        <Delete />
                      </IconButton>
                    </ListItem>
                  ))}
              </List>

              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                sx={{ mt: 3 }}
              >
                Insurance Files:
              </Typography>
              <List>
                {cottoninsurancefiles
                  .filter(
                    (fileName) =>
                      fileName !== "metadata.json" && fileName !== "Thumbs.db",
                  )
                  .map((fileName, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        mb: 1,
                        "&:hover": { bgcolor: "#f5f5f5" },
                      }}
                    >
                      <InsertDriveFile sx={{ mr: 2, color: "#1976d2" }} />
                      <ListItemText primary={fileName} />
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={!!loadingDownload[fileName]}
                        onClick={() =>
                          handleDownload(
                            `downloadInsuranceCottonFile/${fileName}`,
                          )
                        }
                        startIcon={
                          loadingDownload[fileName] ? null : <GetApp />
                        }
                        sx={{ mr: 1 }}
                      >
                        {loadingDownload[fileName] ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Download"
                        )}
                      </Button>
                      <IconButton
                        color="error"
                        onClick={() => handlecottoninsuranceDelete(fileName)}
                        size="small"
                      >
                        <Delete />
                      </IconButton>
                    </ListItem>
                  ))}
              </List>

              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                sx={{ mt: 3 }}
              >
                Marketing Files:
              </Typography>
              <List>
                {cottonmarketingfiles
                  .filter(
                    (fileName) =>
                      fileName !== "metadata.json" && fileName !== "Thumbs.db",
                  )
                  .map((fileName, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        mb: 1,
                        "&:hover": { bgcolor: "#f5f5f5" },
                      }}
                    >
                      <InsertDriveFile sx={{ mr: 2, color: "#1976d2" }} />
                      <ListItemText primary={fileName} />
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={!!loadingDownload[fileName]}
                        onClick={() =>
                          handleDownload(
                            `downloadMarketingCottonFile/${fileName}`,
                          )
                        }
                        startIcon={
                          loadingDownload[fileName] ? null : <GetApp />
                        }
                        sx={{ mr: 1 }}
                      >
                        {loadingDownload[fileName] ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Download"
                        )}
                      </Button>
                      <IconButton
                        color="error"
                        onClick={() => handlecottonmarketingDelete(fileName)}
                        size="small"
                      >
                        <Delete />
                      </IconButton>
                    </ListItem>
                  ))}
              </List>
            </Paper>
          </Container>
        </div>
      );
    }
  }

  return (
    <div>
      <AppBar position="static" color="default">
        <Paper elevation={3}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Admin Tabs"
            variant="fullWidth"
            indicatorColor="secondary"
            textColor="primary"
          >
            {adminCrops.includes("Corn") && (
              <Tab label="Corn" {...a11yProps(0)} />
            )}
            {adminCrops.includes("Cotton") && (
              <Tab label="Cotton" {...a11yProps(1)} />
            )}
          </Tabs>
        </Paper>
      </AppBar>
      <Paper
        elevation={2}
        style={{
          padding: 20,
          margin: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Welcome, {username}!
        </Typography>
        <div>
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 10 }}
            onClick={handleProfileClick}
          >
            My Profile
          </Button>

          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 10 }}
            onClick={handleMarketingPricesClick}
          >
            Contract Prices
          </Button>

          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 10 }}
            onClick={() =>
              navigate("/fielddata", {
                state: { cropType: activeCropType },
              })
            }
          >
            Field Data Management
          </Button>

          <Button
            variant="contained"
            color="secondary" // Change the color for distinction, if desired
            onClick={handleManageFiles}
            style={{ marginRight: 10 }}
          >
            Manage Files
          </Button>

          <Button variant="contained" color="primary" onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </Paper>
      {showCorn && (
        <TabPanel value={value} index={0}>
          <CornAdminPage />
        </TabPanel>
      )}

      {showCotton && (
        <TabPanel value={value} index={showCorn ? 1 : 0}>
          <CottonAdminPage />
        </TabPanel>
      )}
    </div>
  );
}

export default FilterAdminPage;
